import { BundleCard, CardCorners } from '@setplex/arcana'
import type { UiTvShowBundleInfo } from '~/entities/shows/bundles'
import type { UiTvBundleInfo } from '~/entities/tv/bundles'
import type { UiVodBundleInfo } from '~/shared/interfaces'
import type { ViewRow } from '../../model'
import { getBundleCardConfig } from '../lib'

export const CustomBundleCard = ({
  item,
  row,
}: {
  row: ViewRow
  item: UiVodBundleInfo | UiTvBundleInfo | UiTvShowBundleInfo
}) => {
  const { rented, name, labelPrice, landscapeImageUrl, quantityText, link } =
    item

  const {
    appearance: {
      style: { posterSize },
    },
  } = row

  const { titleFont, subTitleFont, verticalGap } =
    getBundleCardConfig(posterSize)

  return (
    <a href={link}>
      <BundleCard
        corners={CardCorners.CORNERS_25}
        title={name}
        subtitle={quantityText}
        purchaseTitle={labelPrice}
        rented={rented}
        posterUrl={landscapeImageUrl}
        fontSubtitle={subTitleFont}
        fontTitle={titleFont}
        verticalGap={verticalGap}
      />
    </a>
  )
}
